import Dashboard from "./dashboard.vue";

const dashboardRoutes = [
  {
    path: "/",
    component: Dashboard,
    name: "dashboard.index",
    meta: {
      auth: true
    }
  }
];

export default dashboardRoutes;
